import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { BACKEND_URL } from "../config";
import axios from "axios";
import { CartType } from "../context/CartContext";

const getVoucher = (voucher: string) => {
    const url = `${BACKEND_URL}/api/v1/promotion-codes/${voucher}`;
    return axios.request({
        url: url,
        withCredentials: true,
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        method: "GET",
    });
};

export const useGetVoucher = (voucher: string) => {
    return useQuery({
        queryKey: ["voucher", voucher],
        queryFn: async () => {
            const response = await getVoucher(voucher);
            return response.data;
        },
        enabled: voucher !== "",
        retry: 1,
    });
};

const postPurchase = async (cart: {
    domains: Array<{ domain: string; auth_code?: string; hosting: string }>;
    voucher: string;
    send_invoice: boolean;
}) => {
    const url = `${BACKEND_URL}/api/v1/cart`;
    return axios.request({
        url: url,
        withCredentials: true,
        data: cart,
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        method: "POST",
    });
};

export const usePurchase = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: [],
        mutationFn: async ({ domains, voucher, send_invoice }: Partial<CartType>) => {
            const response = await postPurchase({
                domains: domains.map((d) => {
                    return { domain: d.name, auth_code: d.authCode, hosting: d.hosting };
                }),
                voucher: voucher,
                send_invoice: send_invoice,
            });
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [`${BACKEND_URL}api/v1/domains`], refetchType: "all" });
        },
    });
};
